import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getPartnerBalances } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'

const PartnerBalances = () => {
  const report = useFinanceObservable<any[]>(
    () =>
      getPartnerBalances({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<any[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Partner Balances"
      isLoading={report.loading}
      rows={report.data || []}
      columns={[
        {
          name: 'Code',
          selector: (row) => row.partner_code || row.code || '--',
        },
        {
          name: 'Partner',
          selector: (row) => row.partner_name || row.name || '--',
        },
        {
          name: 'Receivable',
          selector: (row) => row.receivable_balance ?? '--',
        },
        { name: 'Payable', selector: (row) => row.payable_balance ?? '--' },
        { name: 'Net Balance', selector: (row) => row.net_balance ?? '--' },
      ]}
    />
  )
}

export default PartnerBalances
